import React, { useEffect, useState } from 'react';
import { Input, Select, Button, Space, Tooltip } from 'antd';
import { 
  SearchOutlined, 
  InfoCircleOutlined,
  HomeOutlined,
  EnvironmentOutlined,
  TagOutlined,
  UserOutlined
} from '@ant-design/icons';

const { Option } = Select;

/**
 * Enhanced search component with category selection
 * 
 * @param {Function} onSearch - Handler for search action
 * @param {string} initialValue - Initial search value
 * @param {string} initialCategory - Initial search category
 * @param {Function} getData - Function to fetch data based on search
 */
const EnhancedSearchComponent = ({getData , onSearch, initialValue = '', initialCategory = 'all' }) => {
  const [searchValue, setSearchValue] = useState(initialValue);
  const [searchCategory, setSearchCategory] = useState(initialCategory);

  const handleSearch = () => {
    onSearch(searchValue, searchCategory);
  };

  
    
      useEffect(() => {
        if (searchValue.length >= 2) {
          onSearch(searchValue);
         
        } else if (searchValue.length === 0) {
          getData();
        }
      }, [searchValue]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Space className="flex items-center">
      <Select
        value={searchCategory}
        onChange={setSearchCategory}
        style={{ width: 150 }}
      >
        <Option value="all">
          <Space>
            <SearchOutlined />
            All Fields
          </Space>
        </Option>
        <Option value="property">
          <Space>
            <HomeOutlined />
            Property ID/Title
          </Space>
        </Option>
        <Option value="address">
          <Space>
            <EnvironmentOutlined />
            Address
          </Space>
        </Option>
        <Option value="postcode">
          <Space>
            <TagOutlined />
            Postcode
          </Space>
        </Option>
        <Option value="customer">
          <Space>
            <UserOutlined />
            Customer Name
          </Space>
        </Option>
      </Select>
      
      <Input
        placeholder={
          searchCategory === 'all' ? "Search orders by any field..." :
          searchCategory === 'property' ? "Search by property ID or title..." :
          searchCategory === 'address' ? "Search by address..." :
          searchCategory === 'postcode' ? "Search by postcode..." :
          "Search by customer name..."
        }
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyPress={handleKeyPress}
        style={{ width: 250 }}
        suffix={
          <Tooltip title="Search through orders by property, address, postcode, or customer">
            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
          </Tooltip>
        }
      />
      
      <Button
        type="primary"
        icon={<SearchOutlined />}
        onClick={handleSearch}
        className="bg-golden-navy"
      >
        Search
      </Button>
    </Space>
  );
};

export default EnhancedSearchComponent;